import { useState, useEffect } from "react";
import axios from "axios";
import { Col } from "react-bootstrap";
import { CURRENTS_CARDS_URL } from "../config";
import { stripHtml } from "../utils/string";

const CurrentCards = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(CURRENTS_CARDS_URL)
      .then((res) => setCards(Array.isArray(res.data) ? res.data : []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Col lg={12}>
        <div className="text-center py-5">Loading...</div>
      </Col>
    );
  }

  if (error) {
    return (
      <Col lg={12}>
        <div className="text-center py-5 text-muted">
          Unable to load content. Please try again later.
        </div>
      </Col>
    );
  }

  return (
    <>
      {cards.map((card) => (
        <Col lg={4} md={12} sm={12} key={card.id}>
          <div
            className="featured_card text-center mb-5"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="card_header mb-3">
              <img src={card.image} alt="" />
            </div>
            <div className="card_body">
              <h4>{card.header}</h4>
              <p>{stripHtml(card.description)}</p>
            </div>
          </div>
        </Col>
      ))}
    </>
  );
};

export default CurrentCards;
